import React from 'react';
import Button from '@mui/material/Button';
import { useTheme, lighten } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';

const FilledButton = React.forwardRef(function FilledButton(
  { to, state, text, color = 'success', size = 'large', sx = {}, ...props },
  ref,
) {
  const theme = useTheme();
  const mainColor = theme.palette[color]?.main || theme.palette.primary.main;

  return (
    <Button
      ref={ref}
      component={to ? RouterLink : undefined}
      to={to}
      state={state}
      variant="contained"
      color={color}
      size={size}
      sx={{
        backgroundColor: mainColor,
        color: '#fff',
        '&:hover': { backgroundColor: lighten(mainColor, 0.2) },
        ...sx,
      }}
      {...props}
    >
      {text}
    </Button>
  );
});

export default FilledButton;
